import { useEffect, useRef, useState } from 'react';

function PayPage({ url }: { url: string }) {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [fallback, setFallback] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      try {
        const doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        if (!doc || (doc.body && doc.body.innerHTML.length === 0)) {
          setFallback(true);
        }
      } catch (e) {
        setFallback(true);
      }
    } else {
      setFallback(true);
    }
  }, 2000);

  return () => clearTimeout(timer);

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

    useEffect(() => {
        if (fallback && url) {
            window.open(url, '_blank');
        }
    }, [fallback, url]);

    if (fallback) {
        return (
            <div className="text-center mt-8 text-lg">
                Перенаправляем вас на страницу оплаты...
            </div>
        );
    }

    return (
        <iframe
            ref={iframeRef}
            src={url}
            width="100%"
            height="800"
            style={{ border: 'none' }}
            title="Оплата"
        />
    );
}
export default PayPage;